export default "__VITE_ASSET__Dxw1_D1Y__"